/** The one breakpoint: a phone is anything narrower than 768px. */
export const PHONE_QUERY = "(max-width: 767px)";
